import { render } from "./view-image.vue?vue&type=template&id=7a20b908&scoped=true&ts=true"
import script from "./view-image.vue?vue&type=script&lang=ts"
export * from "./view-image.vue?vue&type=script&lang=ts"

import "./view-image.vue?vue&type=style&index=0&id=7a20b908&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a20b908"]])

export default __exports__